const ourPeopleData = {
  titlePart1: 'Conoce a nuestro',
  titlePart2: 'Dream Team',
  description: 'En Fingo, trabajamos con compromiso y cercanía para que tu empresa tenga el respaldo que necesita, cuando lo necesita.',
};

export default ourPeopleData;
